import { sendGAEvent as originalSendGAEvent } from '@next/third-parties/google';
import config from '@pkgs/shared-client/config';

export function isGAReady(): boolean {
	return Boolean(config.googleAnalytics.enabled && typeof window !== 'undefined' && window.gtag);
}

const sendGAEvent: typeof originalSendGAEvent = (...args: any[]) => {
	if (!config.googleAnalytics.enabled) {
		return;
	}

	originalSendGAEvent(...args);
};

export default sendGAEvent;
